import { render, staticRenderFns } from "./lixeira.vue?vue&type=template&id=36444586"
import script from "./lixeira.vue?vue&type=script&lang=js"
export * from "./lixeira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports